<template>
  <div class="compete-rule">
    <moduleTitle title1="赛事规则" title2="RULES" id="compete-rule" />
    <div id="compete-rule1">
      <div
        class="rule-item"
        v-for="(list, index) in rules"
        :key="`${list.title}${index}`"
      >
        <div class="item-wrap" v-if="!list.children">
          <div class="item-title">{{ list.title }}</div>
          <div
            class="item-text"
            v-for="(item, index1) in list.texts"
            :key="index1"
          >
            <span class="circle"></span>
            <div>{{ item }}</div>
          </div>
        </div>
        <div class="item-wrap" v-else>
          <div
            v-for="(item, index1) in list.children"
            :key="item.title"
            :style="{
              'margin-bottom': index1 < list.children.length - 1 ? '20px' : '0'
            }"
          >
            <div class="item-title">{{ item.title }}</div>
            <div
              class="item-text"
              v-for="(item1, index1) in item.texts"
              :key="index1"
              :class="index1 === 0 ? 'no-circle' : ''"
            >
              <h-icon name="time_fill" v-if="index1 === 0"></h-icon>
              <span class="circle" v-else></span>
              <div>{{ item1 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moduleTitle from './moduleTitle'
export default {
  name: 'CompeteRule',
  components: { moduleTitle },
  data() {
    return {
      rules: window.financialCompetitionResource.rules
    }
  }
}
</script>

<style lang="scss" scoped>
#compete-rule,
#compete-rule1 {
  opacity: 0;
}
.compete-rule {
  max-width: 1200px;
  margin: 0 auto;
  padding: 64px 0 44px;
}
.rule-item {
  border-radius: 27px;
  margin-bottom: 24px;
  overflow: hidden;
  padding: 2px;
  background-color: #fff;
  transition: 500ms;
  background-image: linear-gradient(to left, #fff, #fff);
  &:hover {
    transition: 500ms;
    background-image: linear-gradient(to left, #0ff4f1, #3060ff);
  }
  .item-wrap {
    padding: 32px 80px 32px 50px;
    border-radius: 25px;
    background-color: #fff;
    overflow: hidden;
  }
  &.active {
    box-shadow: 0px 14px 40px 0px rgba(230, 230, 230, 1);
  }
  .item-title {
    height: 24px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .item-text {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666;
    line-height: 22px;
    display: flex;
    align-items: baseline;
    .circle {
      display: inline-block;
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #666;
      margin-right: 2px;
    }
    // &::before {
    // }
  }
  .no-circle {
    .h-icon {
      position: relative;
      right: 2px;
    }
    &::before {
      content: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeRule.vue